import { render, staticRenderFns } from "./smallOomADT.vue?vue&type=template&id=52a9a32a&scoped=true"
import script from "./smallOomADT.vue?vue&type=script&lang=js"
export * from "./smallOomADT.vue?vue&type=script&lang=js"
import style0 from "./smallOomADT.vue?vue&type=style&index=0&id=52a9a32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9a32a",
  null
  
)

export default component.exports